module.exports = __webpack_public_path__ + "static/media/Weaver.85a98be1.png";